import { replace } from 'ramda';
var trimStart = replace(/\s+$/, '');
export default trimStart;